import { cn } from '@/lib/shadcn/utils';
import { ShortlistHeader } from '@/modules/public-shortlist/components/ShortlistHeader';
import { SHORTLIST_MAX_WIDTH_CLASS } from '@/modules/public-shortlist/constants';
import { Skeleton } from '@/modules/ui/components/skeleton/Skeleton';

export function ShortlistCandidateDetailSkeleton() {
  return (
    <div className="bg-neutral-120 flex min-h-screen flex-col">
      <ShortlistHeader
        onCtaClick={() => {}}
        showCta
        contentClassName={SHORTLIST_MAX_WIDTH_CLASS}
      />

      <main className="flex-1" aria-busy aria-label="Loading candidate profile">
        <div
          className={cn(
            'mx-auto w-full px-4 py-10 sm:px-6 md:py-14 lg:px-8',
            SHORTLIST_MAX_WIDTH_CLASS,
          )}
        >
          <Skeleton className="mb-6 h-4 w-32" />

          <header>
            <Skeleton className="h-8 w-48 md:h-9" />
            <Skeleton className="mt-2 h-4 w-72 max-w-full" />
          </header>

          <section className="mt-8 space-y-4">
            <Skeleton className="h-6 w-44" />
            {Array.from({ length: 3 }).map((_, index) => (
              <Skeleton
                key={`strength-${index}`}
                className="h-20 w-full rounded-lg"
              />
            ))}
          </section>

          <section className="mt-8 space-y-4">
            <Skeleton className="h-6 w-28" />
            {Array.from({ length: 4 }).map((_, index) => (
              <Skeleton
                key={`experience-${index}`}
                className="h-4 w-full max-w-md"
              />
            ))}
          </section>

          <Skeleton className="mt-10 h-32 w-full rounded-2xl" />
        </div>
      </main>
    </div>
  );
}
